/*
 * Tracking Meta + TikTok + GA4.
 *
 * Trei reguli care nu se încalcă:
 *
 * 1. Numele afișat al produsului nu ajunge NICIODATĂ într-un eveniment.
 *    Se trimite numele neutru din settings.product_safe_name. Clasificatoarele
 *    platformelor de reclame citesc parametrii evenimentelor, nu doar pagina.
 *
 * 2. Dacă requireConsent este activ, niciun script de tracking din browser nu
 *    se încarcă până la acceptare. Evenimentele server-side (CAPI) se trimit
 *    oricum — decizie asumată a clientului, iar textele din banner și de la
 *    formular sunt scrise ca să nu afirme altceva.
 *
 * 3. Identificatorii de click (fbclid, ttclid) se captează ÎNTOTDEAUNA, în
 *    cookie first-party. E singura punte către atribuire când vizitatorul a
 *    refuzat cookie-urile: pixelul nu se încarcă, deci `_fbp` și `_fbc` nu
 *    apar niciodată, iar fără ele CAPI ar trimite evenimente pe care Meta nu
 *    le poate lega de nicio reclamă.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('zv-tracking-config');
  if (!configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var started = false;
  var intentBound = false;
  var relayedView = false;

  /* ── Cookie-uri first-party ────────────────────────────────────────────── */

  var COOKIE_DAYS = 90;

  function readCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : null;
  }

  function writeCookie(name, value) {
    // Domeniul rămâne implicit (gazda curentă): pe zorvia.ro cookie-ul e
    // vizibil și subdomeniului api.zorvia.ro, care are nevoie de el.
    document.cookie =
      name + '=' + value + ';path=/;max-age=' + COOKIE_DAYS * 86400 + ';SameSite=Lax';
  }

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  /**
   * Captarea identificatorilor de click. Rulează înaintea oricărei decizii de
   * consimțământ, pentru că nu încarcă niciun script terț: doar reține în
   * prima parte de unde a venit vizitatorul.
   */
  /** Partea de `fb.1.<ora>.<fbclid>` care e chiar id-ul clickului. */
  function clickIdOf(fbc) {
    if (!fbc) return null;
    var parts = String(fbc).split('.');
    return parts.length > 3 ? parts.slice(3).join('.') : null;
  }

  function captureClickIds() {
    var fbclid = param('fbclid');
    // Un click NOU rescrie cookie-ul. `_fbc` trăiește 90 de zile: cine a mai
    // văzut o reclamă acum o lună îl are deja scris, iar dacă azi dă click pe
    // alta și comandă, conversia s-ar duce la reclama veche.
    //
    // Pixelul Meta nu rescrie cookie-ul, dar ține separat lista `multiFbc` în
    // localStorage, cu cel mai recent click PRIMUL — deci el atribuie clickului
    // nou. Fără linia asta, evenimentul din browser și cel prin CAPI ar pleca
    // pe reclame diferite.
    //
    // Același click nu rescrie nimic: altfel fiecare reîncărcare ar muta ora
    // clickului în prezent și fereastra de atribuire ar începe iar de la zero.
    if (fbclid && clickIdOf(readCookie('_fbc')) !== fbclid) {
      writeCookie('_fbc', 'fb.1.' + Date.now() + '.' + fbclid);
    }
    var ttclid = param('ttclid');
    if (ttclid && !readCookie('_ttclid')) {
      writeCookie('_ttclid', ttclid);
    }
    // `_fbp` e doar un identificator de browser generat aleatoriu. Dacă
    // pixelul nu apucă să-l scrie, îl generăm noi în același format, ca
    // evenimentele server-side să aibă totuși de ce se lega.
    if (!readCookie('_fbp')) {
      writeCookie('_fbp', 'fb.1.' + Date.now() + '.' + Math.floor(Math.random() * 1e10));
    }
  }

  /* ── Mod test (Meta Test Events / TikTok Debug) ────────────────────────── */

  /**
   * Se pornește manual, cu `?zv_test=<cod>` pe orice pagină a magazinului, și
   * se stinge cu `?zv_test=off` sau odată cu tabul.
   *
   * De ce nu e pornit din server pentru tot traficul: un eveniment marcat ca
   * test apare în Test Events, dar NU intră în raportarea campaniilor. Marcat
   * global, ar goli raportarea în tăcere. Așa, doar sesiunea celui care
   * verifică e marcată; vizitatorii reali nu trimit nimic.
   *
   * Codul nu e o parolă: serverul îl compară cu cel configurat la el, deci din
   * browser nu se poate inventa unul.
   */
  var TEST_KEY = 'zv_test';
  var TEST_SHAPE = /^[A-Za-z0-9_-]{4,64}$/;

  function readTestCode() {
    var asked = param(TEST_KEY);
    var valid = asked && TEST_SHAPE.test(asked) ? asked : null;
    try {
      if (asked === 'off' || asked === '0') {
        sessionStorage.removeItem(TEST_KEY);
        return null;
      }
      if (valid) {
        sessionStorage.setItem(TEST_KEY, valid);
        return valid;
      }
      return sessionStorage.getItem(TEST_KEY);
    } catch (e) {
      // Safari în navigare privată aruncă la scriere; codul din URL tot merge.
      return valid;
    }
  }

  var TEST_CODE = readTestCode();

  /**
   * Un indicator vizibil. Fără el, „de ce nu apar evenimentele în Test Events"
   * are două cauze imposibil de distins: codul greșit, sau modul test stins.
   */
  function showTestBadge(code) {
    var el = document.createElement('div');
    el.setAttribute('data-zv-test-badge', '');
    el.textContent = 'MOD TEST · ' + code;
    el.style.cssText = 'position:fixed;bottom:12px;left:12px;z-index:2147483647;' +
      'background:#b3261e;color:#fff;padding:8px 10px;border-radius:6px;' +
      'font:600 12px/1 ui-monospace,SFMono-Regular,Menlo,monospace;' +
      'letter-spacing:.04em;pointer-events:none;box-shadow:0 2px 8px rgba(0,0,0,.3)';
    (document.body || document.documentElement).appendChild(el);
  }

  /* ── Releu server-side ─────────────────────────────────────────────────── */

  function eventId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'zv-' + Date.now() + '-' + Math.floor(Math.random() * 1e9);
  }

  /**
   * Trimite evenimentul și către endpointul propriu. Fiind first-party, cu o
   * cale neutră, trece de blocklist-ele care omoară connect.facebook.net —
   * de aceea are rost chiar și când pixelul s-a încărcat.
   */
  function relay(name, id) {
    if (!cfg.trackEndpoint) return;
    if (name === 'ViewContent') {
      if (relayedView) return;
      relayedView = true;
    }
    var sel = selection();
    var payload = JSON.stringify({
      event: name,
      eventId: id,
      sourceUrl: window.location.href,
      referrer: document.referrer || null,
      value: sel.value,
      numItems: sel.quantity,
      currency: cfg.currency,
      contentId: cfg.contentId,
      contentName: cfg.contentName,
      contentCategory: cfg.contentCategory,
      fbp: readCookie('_fbp'),
      fbc: readCookie('_fbc'),
      fbclid: param('fbclid'),
      ttclid: param('ttclid') || readCookie('_ttclid'),
      ttp: readCookie('_ttp'),
      // Null pentru orice vizitator real: doar sesiunea de verificare e marcată.
      testCode: TEST_CODE
    });

    // `keepalive` ca evenimentul să plece chiar dacă utilizatorul navighează
    // imediat după click.
    try {
      window.fetch(cfg.trackEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true
      }).catch(function () { /* tracking-ul nu are voie să facă zgomot */ });
    } catch (e) {
      /* browser fără fetch: renunțăm în tăcere */
    }
  }

  /* ── Pixeli ────────────────────────────────────────────────────────────── */

  function loadMetaPixel(id) {
    if (!id || window.fbq) return;
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', id);
  }

  function loadTiktokPixel(id) {
    if (!id || window.ttq) return;
    /* eslint-disable */
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
      ttq.setAndDefer = function (obj, method) {
        obj[method] = function () { obj.push([method].concat(Array.prototype.slice.call(arguments, 0))); };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (id) {
        var inst = ttq._i[id] || [];
        for (var j = 0; j < ttq.methods.length; j++) ttq.setAndDefer(inst, ttq.methods[j]);
        return inst;
      };
      ttq.load = function (e, n) {
        var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = url;
        ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
        ttq._o = ttq._o || {}; ttq._o[e] = n || {};
        var script = d.createElement('script');
        script.type = 'text/javascript'; script.async = !0; script.src = url + '?sdkid=' + e + '&lib=' + t;
        var first = d.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
      };
    }(window, document, 'ttq');
    /* eslint-enable */
    window.ttq.load(id);
    window.ttq.page();
  }

  function loadGa4(id) {
    if (!id || window.__zvGa4) return;
    window.__zvGa4 = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id, { send_page_view: true });
  }

  /* ── Evenimente ────────────────────────────────────────────────────────── */

  /**
   * Ce are omul ales ACUM în formular.
   *
   * `cod-form.js` scrie `window.ZV_SELECTION` de fiecare dată când se schimbă
   * cantitatea. Fără asta, `InitiateCheckout` ar raporta mereu prețul unei
   * bucăți, iar Meta ar optimiza pe o valoare care nu e cea comandată.
   *
   * La `ViewContent` obiectul încă nu există — se scrie abia la
   * DOMContentLoaded, iar evenimentul pleacă înainte. E și corect: la
   * afișarea paginii nimeni nu a ales nimic.
   */
  function selection() {
    var fallback = { value: parseFloat(cfg.value) || 0, quantity: 1 };
    var s = window.ZV_SELECTION;
    if (!s) return fallback;

    var qty = parseInt(s.quantity, 10);
    var value = parseFloat(s.value);
    if (!(qty > 0) || !isFinite(value) || value <= 0) return fallback;
    return { value: value, quantity: qty };
  }

  function contentPayload() {
    var sel = selection();
    return {
      content_name: cfg.contentName,
      content_category: cfg.contentCategory,
      content_ids: [cfg.contentId],
      content_type: 'product',
      num_items: sel.quantity,
      value: sel.value,
      currency: cfg.currency
    };
  }

  function tiktokPayload() {
    var sel = selection();
    return {
      contents: [{
        content_id: cfg.contentId,
        content_type: 'product',
        content_name: cfg.contentName,
        quantity: sel.quantity,
        // TikTok cere prețul pe bucată, nu totalul liniei.
        price: Math.round((sel.value / sel.quantity) * 100) / 100
      }],
      value: sel.value,
      currency: cfg.currency
    };
  }

  function loadPixels() {
    loadMetaPixel(cfg.pixelId);
    loadTiktokPixel(cfg.tiktokPixelId);
    loadGa4(cfg.ga4Id);
  }

  function fireViewContent() {
    if (started) return;
    started = true;

    var value = parseFloat(cfg.value) || 0;
    var id = eventId();

    if (window.fbq) {
      window.fbq('track', 'PageView');
      if (cfg.isProduct) {
        window.fbq('track', 'ViewContent', contentPayload(), { eventID: id });
      }
    }
    if (window.ttq && cfg.isProduct) {
      window.ttq.track('ViewContent', tiktokPayload(), { event_id: id });
    }
    if (window.gtag && cfg.isProduct) {
      window.gtag('event', 'view_item', {
        currency: cfg.currency,
        value: value,
        page_variant: cfg.variantName,
        items: [{
          item_id: cfg.contentId,
          item_name: cfg.contentName,
          item_category: cfg.contentCategory,
          price: value,
          quantity: 1
        }]
      });
    }

    if (cfg.isProduct) relay('ViewContent', id);
  }

  // Intenția de comandă: apăsarea unui CTA. Semnal intermediar util, pentru că
  // între ViewContent și Purchase nu se mai întâmplă nimic măsurabil.
  function bindIntent() {
    // Fără garda asta, acceptarea consimțământului ar lega ascultătorul a doua
    // oară și fiecare click pe CTA ar produce două InitiateCheckout.
    if (intentBound) return;
    intentBound = true;

    document.addEventListener('click', function (ev) {
      var el = ev.target.closest('[data-zv-cta]');
      if (!el) return;

      var id = eventId();
      if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', contentPayload(), { eventID: id });
      }
      if (window.ttq) {
        window.ttq.track('InitiateCheckout', tiktokPayload(), { event_id: id });
      }
      if (window.gtag) {
        var sel = selection();
        window.gtag('event', 'begin_checkout', {
          currency: cfg.currency,
          value: sel.value,
          page_variant: cfg.variantName,
          items: [{
            item_id: cfg.contentId,
            item_name: cfg.contentName,
            item_category: cfg.contentCategory,
            price: Math.round((sel.value / sel.quantity) * 100) / 100,
            quantity: sel.quantity
          }]
        });
      }
      relay('InitiateCheckout', id);
    }, { passive: true });
  }

  /* ── Pornire ───────────────────────────────────────────────────────────── */

  // Întotdeauna, fără să aștepte consimțământul: nu încarcă niciun script terț.
  captureClickIds();

  if (TEST_CODE) {
    showTestBadge(TEST_CODE);
    // Evenimentele din browser (fbq) nu poartă cod de test — pixelul Meta nu
    // are noțiunea asta. Ele apar oricum în Test Events cât timp navighezi
    // logat cu contul care administrează pixelul. Codul e pentru CAPI.
    if (window.console && console.info) {
      console.info(
        '[Zorvia] Mod test activ: ' + TEST_CODE + '. Evenimentele server-side ' +
        'pleacă marcate spre Test Events și NU intră în raportarea campaniilor. ' +
        'Oprire: ?zv_test=off'
      );
    }
  }

  function startBrowserTracking() {
    loadPixels();
    fireViewContent();
    bindIntent();
  }

  if (!cfg.requireConsent || window.ZV_CONSENT === 'accepted') {
    startBrowserTracking();
  } else {
    // Pixelii așteaptă acceptarea. Releul server-side nu: el nu pune nimic în
    // browserul vizitatorului.
    if (cfg.isProduct) relay('ViewContent', eventId());
    bindIntent();

    document.addEventListener('zv:consent', function (ev) {
      if (ev.detail && ev.detail.accepted) startBrowserTracking();
    });
  }
})();
